function IsleOfMan({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1399)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#D80027"/>
        <path d="M21.9241 10.7256L20.7933 14.7613L17.4001 14.1348L15.216 9.63257L9.31558 11.7264L8.85027 10.4151L7.30652 10.2249L8.46971 13.503L12.5303 12.4646L13.6842 15.7164L10.8772 19.859L15.6408 23.9219L14.7379 24.9805L15.345 26.4126L17.6024 23.7661L14.6728 20.7688L16.912 18.1436L21.9031 18.5032L23.0399 12.3463L24.4081 12.599L25.3449 11.3571L21.9241 10.7256Z" fill="#F0F0F0"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default IsleOfMan;
